cacheService.$inject = [
  '$cacheFactory'
];

export default function cacheService($cacheFactory) {
  class CacheService {
    clear() { //eslint-disable-line
      const $httpCache = $cacheFactory.get('$http');

      if ($httpCache) {
        $httpCache.removeAll();
      }
    }
  }

  return new CacheService();
}



// WEBPACK FOOTER //
// ./src/services/cacheService.js